module.exports = __webpack_public_path__ + "img/21.4fe1b3f2.jpg";